import { render, staticRenderFns } from "./MemberAuthorizationManager.vue?vue&type=template&id=77f9d54f&scoped=true"
import script from "./MemberAuthorizationManager.vue?vue&type=script&lang=js"
export * from "./MemberAuthorizationManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f9d54f",
  null
  
)

export default component.exports